/* global angular, analytics_data, utag */

var informaSearchApp = angular.module('informaSearchApp');

var InformaResultsController = function InformaResultsController($scope, $rootScope, $sanitize, $location, searchService, viewHeadlinesStateService, $timeout, $window, facetAvailabilityService) {

    var vm = this;
    vm.starting = true;

    vm.service = searchService;
    
    vm.docs = [];
    vm.displayedDocs = [];
    vm.showAllResults = false;
    vm.searchType = vm.service.getSearchType();
    vm.location = $location;
    vm.themeOmdia = angular.element(document.body).hasClass('theme-omdia');
    
    // Show shimmer on initial load as placeholder for results
    if (vm.themeOmdia && window.INFORMA && window.INFORMA.Shimmer) {
        // Wait for Angular to compile the DOM, then show shimmer
        $timeout(function () {
            // Use a container that exists on page load
            var searchContainer = $(".tab-content").first();
            if (searchContainer.length) {
                INFORMA.Shimmer.Show(searchContainer, {
                    rows: 10,
                    type: "card",
                });
            }
        }, 0);
    }

    vm.showModalAndStopPropagation = function($event) {
        $event.stopPropagation();
        $('#custom-popup-become-client').modal('show');
        $event.preventDefault();
    };

    $scope.headlinesOnly = viewHeadlinesStateService;
    $scope.tabselected = vm.searchType || 'content';
    var count = 0;

    //Sri ram code IPP-7254
    $rootScope.updateSearchType = function (tsval) {
        $scope.tabselected = tsval;
        var filterVal = $scope.tabselected === "content" ? "" : $scope.tabselected;
        var searchTypeFilter = vm.service.getFilter('searchtype');
        if (searchTypeFilter) {
            searchTypeFilter.setValue(filterVal);
        } else {
            vm.service.createFilter('searchtype', filterVal);
        }

        vm.service.getFilter('page').setValue('1');

        var routeBuilder = vm.service.getRouteBuilder();
        vm.location.search(routeBuilder.getRoute());
        vm.service.query();
    }

    $scope.ReplaceBrowser = function (body) {
      
        const regexp = /<a[^>]*>([^<]+)<\/a>/g;
        const matches = body.matchAll(regexp);

        for (const match of matches) {
            console.log(match);
           
        }
        
    }

    $scope.utagAnalytics = function () {
        if (count > 0) {
             var eventDetails = {
                Number_of_Results: '"' + $(".js-searchTotalResults").text() + '"',
                search_Keyword: '"' + $(".search-bar__field").val() + '"'
            };
            var dataObj = $.extend(analytics_data, eventDetails);
            if (typeof utag !== 'undefined') {
                utag.view(dataObj);
            }
         }
        count = count + 1;
        if(count > 1){
            vm.starting = false;
            INFORMA.Shimmer.Hide();
        }
    };

    $scope.getFormattedDate = function (originalDate) {
        return new Date(originalDate.replace(/T.+/, ''));
    };

    $scope.$watch(function () {
        return searchService.getSearchType();
    }, function () {
        vm.searchType = searchService.getSearchType();
        $scope.tabselected = vm.searchType || 'content';
    });

    $scope.$watch(
    function () {
      return searchService.getResults();
    },
    function () {
      $scope.getpagePosition =
        (searchService._pager.current - 1) * searchService._pager.perPage;
      vm.docs = searchService.getResults();

    //   Show no results message from api
    //   if(!vm.docs.length && !vm.starting) {
    //     $("#searchTop .tab-content").first().html("No Result Found");
    //   }
      
      // Show results based on count
      if (vm.docs && vm.docs.length > 0) {
        var pager = searchService.getPager();
        var isLastPage = pager && pager.current === pager.totalPages();
        
        // Store current page results count and isLastPage on $rootScope for pagination visibility
        $rootScope.currentPageResultsCount = vm.docs.length;
        $rootScope.isLastPage = isLastPage;
        
        $rootScope.loadMoreVisible = false;
        
        var perPage = pager ? pager.perPage : 20; // Default perPage
        
        if (isLastPage && vm.docs.length < 10) {
          vm.displayedDocs = vm.docs.slice(); // Show all results
          vm.showAllResults = true;
        } else if (isLastPage && vm.docs.length >= 10 && vm.docs.length < perPage) {
          vm.displayedDocs = vm.docs.slice(0, 10); // Show first 10 results
          vm.showAllResults = false;
        } else if (isLastPage && vm.docs.length >= perPage) {
          var halfLength = Math.ceil(vm.docs.length / 2);
          vm.displayedDocs = vm.docs.slice(0, halfLength);
          vm.showAllResults = false;
        } else if (!isLastPage) {
          var halfLength = Math.ceil(vm.docs.length / 2);
          vm.displayedDocs = vm.docs.slice(0, halfLength);
          vm.showAllResults = false;
        } else {
          // Fallback: show all
          vm.displayedDocs = vm.docs.slice();
          vm.showAllResults = true;
        }
        // Reset loadMoreClicked flag and loadMoreVisible when new results come in
        vm.loadMoreClicked = false;
        $scope.loadMoreClicked = false;
        $rootScope.loadMoreClicked = false;
        
        // Update loadMoreVisible based on current state
        if (!isLastPage && vm.docs.length > 0) {
          $rootScope.loadMoreVisible = !vm.showAllResults && vm.docs.length > vm.displayedDocs.length;
        } else if (isLastPage && vm.docs.length >= 10) {
          $rootScope.loadMoreVisible = !vm.showAllResults && vm.docs.length > vm.displayedDocs.length;
        } else {
          $rootScope.loadMoreVisible = false;
        }
      } else {
        vm.displayedDocs = [];
        vm.showAllResults = false;
        vm.loadMoreClicked = false;
        $scope.loadMoreClicked = false;
        $rootScope.loadMoreClicked = false;
        $rootScope.currentPageResultsCount = 0;
        $rootScope.isLastPage = false;
      }
      
      $scope.utagAnalytics();
      // Hide shimmer when results are loaded
    //   if (vm.themeOmdia && window.INFORMA && window.INFORMA.Shimmer) {
    //     $timeout(function () {
    //       INFORMA.Shimmer.Hide();
    //     }, 100);
    //   }
    }
  );
    
    // Load More function to show remaining results
    vm.loadMore = function() {
        if (!vm.showAllResults && vm.docs && vm.docs.length > vm.displayedDocs.length) {
            vm.displayedDocs = vm.docs.slice(); // Show all results
            vm.showAllResults = true;
            vm.loadMoreClicked = true;
            $scope.loadMoreClicked = true;
            $rootScope.loadMoreClicked = true;
            $rootScope.loadMoreVisible = false; // Hide pagination when Load More is clicked
            
            // remove shimmer cards after Load More is clicked
            if (vm.themeOmdia) {
                $timeout(function () {
                    var allShimmers = $(".shimmer-card");
                    if (allShimmers.length > 0) {
                        allShimmers.remove();
                    }
                }, 100);
            }
        }
    };
    
    vm.showLoadMore = function() {
        var pager = searchService.getPager();
        var isLastPage = pager && pager.current === pager.totalPages();
        
        if (!vm.docs || vm.docs.length === 0 || vm.showAllResults) {
            $rootScope.loadMoreVisible = false;
            return false;
        }
        
        var shouldShow = false;
        if (isLastPage) {
            shouldShow = vm.docs.length >= 10 && vm.docs.length > vm.displayedDocs.length;
        } else {
            shouldShow = vm.docs.length > vm.displayedDocs.length;
        }
        
        $rootScope.loadMoreVisible = shouldShow;
        return shouldShow;
    };
    
    $scope.showLoadMore = function() {
        return vm.showLoadMore();
    };
    
    vm.loadMoreClicked = false;
    
    $scope.loadMoreClicked = false;
    
    if (!$rootScope.loadMoreClicked) {
        $rootScope.loadMoreClicked = false;
    }

    $scope.filterResult = function (url) {
        window.location = url;
        window.location.reload();
    };

    $scope.fireBookmark = function (article, event, key) {
        window.INFORMA.Spinner.Show($('body'));
        $timeout(function () {
            vm.docs[key].isArticleBookmarked = vm.docs[key].isArticleBookmarked ? false : true;
            window.INFORMA.Spinner.Hide();
        }, 500);
    };

    $scope.$on('refreshPopOuts', function (ngRepeatFinishedEvent) {

		// Enable all facet options when search results land
		// $('.facets__section input').attr('disabled', null);
		facetAvailabilityService.enableFacets();

        if (window.indexPopOuts)
        window.indexPopOuts();
        if (window.indexBookmarks)
        window.indexBookmarks();
        if (window.autoBookmark)
        window.autoBookmark();
        if (window.findTooltips)
        window.findTooltips();
        if (window.renderRevealer)
        window.renderRevealer();
        
    });

    this.forceRefresh = function () {
        $window.location.reload(false);
    };

    vm.triggerHeadingClick = function($event) {
      var $header,
          headerData,
          headerUrl;
      
      if (!vm.themeOmdia || $event.target.tagName === "A") return;

      // get header element
      $header = $($event.currentTarget).find('.search-result__heading');
      headerUrl = $header.attr('ng-href');

      // if url not present on header dont track event either
      if (!headerUrl) return;

      // get and set analytics data from header
      headerData = $header.data('info');
      if(typeof utag !== 'undefined' && headerData) {
        utag.link($.extend(analytics_data, headerData));
      }

      // execute header clickthrough
      window.location = headerUrl;
    }

};

informaSearchApp.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit('refreshPopOuts');
                });
            }
        }
    };
});

informaSearchApp.controller("InformaResultsController", ['$scope', '$rootScope', '$sanitize', '$location', 'searchService', 'viewHeadlinesStateService', '$timeout', '$window', 'facetAvailabilityService', InformaResultsController]);
